import { render, staticRenderFns } from "./EditVeicolo.vue?vue&type=template&id=ed341eec&"
import script from "./EditVeicolo.vue?vue&type=script&lang=ts&"
export * from "./EditVeicolo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports